import { EnvironmentProviders, inject, InjectionToken, Provider, provideEnvironmentInitializer } from "@angular/core";
import { CustomThemeService } from "app/custom-theme.service";
import { UserConfig } from "app/shared/services/model/user-configuration.model";

export const IAPPLY_CONFIG = new InjectionToken<any>('IAPPLY_APP_CONFIG');

// export interface UserConfig {
// }

export type iApplyUserConfig = {
    localConfig?: UserConfig;
    // serverConfig?: UserConfig;
};

export const provideUserConfig = (
    config?: iApplyUserConfig
): Array<Provider | EnvironmentProviders> => {

    const providers: Array<Provider | EnvironmentProviders> = [
        {
            provide: IAPPLY_CONFIG,
            useValue: config ?? { localConfig: new UserConfig() },
        },
        provideEnvironmentInitializer(() => inject(CustomThemeService)),
    ];

    return providers;
}
